import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { ACL_TYPE } from '@openx/types/aclType';
import type { PackageListItem } from '@openx/types/package';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PackagesBulkOperations } from './components/PackagesBulkOperations';
import { PackagesList } from './PackagesList/PackagesList';

export function PackagesListPage() {
  const { t } = useTranslation();
  const [selectedPackages, setSelectedPackages] = useState<PackageListItem[]>([]);
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'action-button',
      href: '/inventory/packages/create',
      isAllowed: isAllowed(isAllowedByCompiledAcl(ACL_TYPE.PACKAGE_CREATE)),
      label: t('Create Package'),
      showAsActionButton: true,
    },
  ];

  const bulkOperationRender = useCallback(
    () => (
      <PackagesBulkOperations selectedPackages={selectedPackages} closeAndUnselect={() => setSelectedPackages([])} />
    ),
    [selectedPackages]
  );

  return (
    <PageHeader
      titlePrefix="OpenXSelect"
      title={t('Packages List')}
      render={() => <HeaderActions actions={actions} />}
      emptyMode={!!selectedPackages.length}
      emptyModeRender={bulkOperationRender}
      sticky
    >
      <PackagesList selectedPackages={selectedPackages} setSelectedPackages={setSelectedPackages} />
    </PageHeader>
  );
}
